import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

const maprouletteChallengeParamsSchema = z.object({
  challengeId: z.coerce.number().positive(),
})

const maprouletteChallengeStatistic = z.array(
  z.strictObject({
    id: z.number(),
    name: z.string(),
    actions: z.object({
      total: z.number(),
      available: z.number(),
      fixed: z.number(),
      falsePositive: z.number(),
      skipped: z.number(),
      deleted: z.number(),
      alreadyFixed: z.number(),
      tooHard: z.number(),
      answered: z.number(),
      validated: z.number(),
      disabled: z.number(),
      avgTimeSpent: z.number(),
      tasksWithTime: z.number(),
    }),
  }),
)

export const Route = createFileRoute('/api/maproulette/statistic-proxy/$challengeId')({
  ssr: false,
  params: {
    parse: (rawParams) => maprouletteChallengeParamsSchema.parse(rawParams),
  },
  server: {
    handlers: {
      GET: async ({ params }) => {
        const { challengeId } = params

        // Note: `app/src/env.d.ts` types get overwritten by Bun gobal process.env types which include `undefined`
        const apiKey = process.env.MAPROULETTE_API_KEY
        if (!apiKey) {
          return Response.json(
            { error: 'MAPROULETTE_API_KEY not configured' },
            { status: 503, headers: { 'Content-Type': 'application/json' } },
          )
        }

        const apiUrl = `https://maproulette.org/api/v2/data/challenge/${challengeId}`

        const response = await fetch(apiUrl, {
          cache: 'force-cache',
          method: 'GET',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            apiKey,
          },
        })
        const json = await response.json()
        const parsed = maprouletteChallengeStatistic.safeParse(json)

        const responseHeaders = {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        }
        if (parsed.success === false || !parsed.data[0]) {
          return Response.json(
            { error: 'Invalid response', parsed, json },
            { status: 500, headers: responseHeaders },
          )
        }

        return Response.json(parsed.data[0].actions, { headers: responseHeaders })
      },
    },
  },
})
